import { render, staticRenderFns } from "./SingleWeaponStats.vue?vue&type=template&id=df34e31c&scoped=true&"
import script from "./SingleWeaponStats.vue?vue&type=script&lang=js&"
export * from "./SingleWeaponStats.vue?vue&type=script&lang=js&"
import style0 from "./SingleWeaponStats.vue?vue&type=style&index=0&id=df34e31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34e31c",
  null
  
)

export default component.exports